import { useCallback, useMemo } from 'react';

import { DashboardId } from '@sternum/web/features/dashboard/models';
import { deleteDashboardIdsAction } from '@sternum/web/features/dashboard/slice';
import { useAppDispatch, useAppSelector } from '@sternum/web/store';

export function useHistoricalDashboardIds(): {
  historicalDashboardIds: DashboardId[];
  deleteDashboardIdsInHistory: (dashboardIdsToRemove: DashboardId[]) => unknown;
} {
  const dispatch = useAppDispatch();
  const dashboardIds = useAppSelector((state) => state.dashboard.lastUsedDashboardIds);

  const historicalDashboardIds = useMemo(() => [...(dashboardIds || [])], [dashboardIds]);
  const deleteDashboardIdsInHistory = useCallback(
    (dashboardIdsToRemove: DashboardId[]) => {
      dispatch(deleteDashboardIdsAction({ dashboardIds: dashboardIdsToRemove }));
    },
    [dispatch],
  );

  /**
   * historicalDashboardIds.at(-1) - already selected dashboard ID
   * historicalDashboardIds.at(-2) - previously selected dashboardId in current category
   */
  return { historicalDashboardIds, deleteDashboardIdsInHistory };
}
